import { useRepoReplicache } from './use-repo-replicache'
import { useTeamReplicache } from './use-team-replicache'
import { useActivePublicTeam } from './team/use-active-public-team'

export const useSelectedTeamAndRepo = () => {
  const teamReplicacheQuery = useTeamReplicache()
  const repoReplicacheQuery = useRepoReplicache()

  const publicData = useActivePublicTeam()

  const isLoading =
    publicData.isInitialLoading &&
    !publicData.data &&
    (teamReplicacheQuery.isLoading || repoReplicacheQuery.isLoading)

  if (isLoading) {
    return { isLoading, data: undefined } as const
  }

  return {
    isLoading,
    teamReplicache: teamReplicacheQuery.data?.replicache,
    repoReplicache: repoReplicacheQuery.data?.replicache,
    data: {
      team: teamReplicacheQuery.data?.team ?? publicData.data?.team,
      repo: repoReplicacheQuery.data?.repo ?? publicData.data?.repo,
    },
    isError: teamReplicacheQuery.isError || repoReplicacheQuery.isError,
  } as const
}
